import auth from '@/Middlewares/auth.js'
import RouteGroup from '@/Setup/Routes/RouteGroup.js'
import Route from '@/Setup/Routes/Route.js'

export const inboxRoutes = new RouteGroup(() => {
  return [
    new Route('inbox.list', '/inbox/:tab?', () =>
      import(/* webpackChunkName: "admin" */ './Pages/List.vue')
    )
      .permission(['inbox.company.view', 'inbox.personal.view'])
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
